import { Flex } from '@chakra-ui/react'

import { createRange } from '@/ui/utils/range'

import { CustomSelect } from '../CustomSelect'

export default function YearInput({
  value,
  onChange,
  min,
  max
}: {
  value: number
  onChange: (data: number) => void
  min?: number
  max?: number
}) {
  return (
    <Flex columnGap={'2'} w={'full'}>
      <Flex
        alignItems={'center'}
        borderColor={'gray.200'}
        borderWidth={'1px'}
        borderRadius={'md'}
        w={'full'}
      >
        <CustomSelect
          options={createRange({
            start: min ?? 2020,
            end: max ?? 2030
          }).map((v) => ({
            label: v.toString(),
            value: v.toString()
          }))}
          value={value.toString()}
          onChange={(d) => onChange(+d)}
          scrollToValue
          maxHeight="300px"
        />
      </Flex>
    </Flex>
  )
}
